module.exports = __webpack_public_path__ + "static/media/json.c875d223.png";